import styled from 'styled-components';

export const CustomTabsCont = styled.div`
  margin: 2rem 2.2rem 0;
  ${({ theme }) => theme.media.tablet`
    margin: 2rem 3.7rem 0;
  `}
`;
